(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

        closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close && disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vivid-benefits"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.vividBenefits) { window.vividBenefits.init(); return; }

    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    function setup(root) {
      if (!root || root.getAttribute('data-vb-ready')) return;
      var sc = root.querySelector('.vbenefits__scroller');
      var cards = [].slice.call(root.querySelectorAll('.vbenefits__card'));
      var dotsWrap = root.querySelector('.vbenefits__dots');
      var dots = dotsWrap ? [].slice.call(dotsWrap.querySelectorAll('.vbenefits__dot')) : [];
      if (!sc || !cards.length) return;
      root.setAttribute('data-vb-ready', '1');
      root.classList.add('is-js');

      var autoMs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      var cur = 0, ticking = false, wasStatic = null;
      var timer = null, resumeT = null, holding = false, inView = true;

      function padLeft() {
        var cs = window.getComputedStyle(cards[0].parentNode);
        return parseFloat(cs.paddingLeft) || 0;
      }

      /* ---- Automatisches Weiterwischen ---- */
      function canAuto() {
        return autoMs > 0 && cards.length > 1 && inView && !holding && !document.hidden &&
               !root.classList.contains('is-static') && !(reduce && reduce.matches);
      }
      function stopAuto() {
        if (timer) { window.clearInterval(timer); timer = null; }
      }
      function startAuto() {
        stopAuto();
        if (!canAuto()) return;
        timer = window.setInterval(function () {
          if (!canAuto()) { stopAuto(); return; }
          goTo(cur + 1 > cards.length - 1 ? 0 : cur + 1);
        }, autoMs);
      }
      /* Nach Nutzer-Interaktion pausieren und nach einem Intervall wieder starten */
      function pauseAuto() {
        holding = true;
        window.clearTimeout(resumeT);
        stopAuto();
      }
      function resumeAuto(delay) {
        window.clearTimeout(resumeT);
        resumeT = window.setTimeout(function () { holding = false; startAuto(); }, delay);
      }

      function update() {
        ticking = false;
        var stat = sc.scrollWidth <= sc.clientWidth + 2;
        root.classList.toggle('is-static', stat);

        var idx = 0;
        if (!stat) {
          if (sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2) {
            idx = cards.length - 1;
          } else {
            var pl = padLeft(), best = Infinity;
            for (var i = 0; i < cards.length; i++) {
              var d = Math.abs(cards[i].offsetLeft - pl - sc.scrollLeft);
              if (d < best) { best = d; idx = i; }
            }
          }
        }
        cur = idx;

        if (dots.length && !stat) {
          dots.forEach(function (dot, j) {
            var on = j === idx;
            dot.classList.toggle('vbenefits__dot--active', on);
            if (on) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        }

        if (stat !== wasStatic) {
          wasStatic = stat;
          if (stat) stopAuto(); else startAuto();
        }
      }

      function queue() {
        if (ticking) return;
        ticking = true;
        (window.requestAnimationFrame || window.setTimeout)(update);
      }

      function goTo(i, instant) {
        if (i < 0) i = 0;
        if (i > cards.length - 1) i = cards.length - 1;
        var left = cards[i].offsetLeft - padLeft();
        var smooth = !instant && !(reduce && reduce.matches);
        if (sc.scrollTo) sc.scrollTo({ left: left, behavior: smooth ? 'smooth' : 'auto' });
        else sc.scrollLeft = left;
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          pauseAuto();
          goTo(i);
          resumeAuto(autoMs * 2);
        });
      });

      sc.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      window.addEventListener('load', queue);
      if (window.ResizeObserver) { new ResizeObserver(queue).observe(sc); }
      if (document.fonts && document.fonts.ready) { document.fonts.ready.then(queue); }

      /* Auto-Wischen pausiert, solange der Finger auf der Reihe liegt, die Maus darüber ist oder ein Element Fokus hat */
      if (autoMs > 0) {
        sc.addEventListener('touchstart', pauseAuto, { passive: true });
        sc.addEventListener('touchend', function () { resumeAuto(autoMs * 2); }, { passive: true });
        sc.addEventListener('touchcancel', function () { resumeAuto(autoMs * 2); }, { passive: true });
        sc.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pauseAuto(); });
        sc.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resumeAuto(autoMs); });
        sc.addEventListener('focusin', pauseAuto);
        sc.addEventListener('focusout', function () { resumeAuto(autoMs * 2); });

        document.addEventListener('visibilitychange', function () {
          if (document.hidden) stopAuto(); else startAuto();
        });

        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              inView = entry.isIntersecting;
              if (inView) startAuto(); else stopAuto();
            });
          }, { threshold: 0.3 }).observe(root);
        }
      }

      /* Theme-Editor: Block anklicken scrollt zur Karte */
      root.addEventListener('shopify:block:select', function (e) {
        var i = cards.indexOf(e.target);
        if (i > -1) goTo(i, true);
      });

      /* Einblenden beim Scrollen – nur, wenn die Sektion noch unterhalb des sichtbaren Bereichs liegt */
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var canReveal = 'IntersectionObserver' in window && !(reduce && reduce.matches) &&
                      root.getBoundingClientRect().top >= vh * 0.9;
      if (canReveal) {
        root.classList.add('is-pre');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              root.classList.remove('is-pre');
              io.disconnect();
            }
          });
        }, { threshold: 0.15 });
        io.observe(root);
      }

      update();
    }

    function init(scope) {
      [].slice.call((scope || document).querySelectorAll('[data-vb]')).forEach(setup);
    }

    window.vividBenefits = { init: init };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vividvergleich"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.vividVergleich) { window.vividVergleich.init(); return; }

    function setup(root) {
      if (!root || root.getAttribute('data-vcmp-ready')) return;
      var tabs = [].slice.call(root.querySelectorAll('.vcmp__tab'));
      var panels = [].slice.call(root.querySelectorAll('.vcmp__panel'));
      if (!panels.length) return;
      root.setAttribute('data-vcmp-ready', '1');
      root.classList.add('is-js');

      function select(key, focus) {
        tabs.forEach(function (t) {
          var on = t.getAttribute('data-tab') === key;
          t.classList.toggle('is-active', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.setAttribute('tabindex', on ? '0' : '-1');
          if (on && focus) t.focus();
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.getAttribute('data-tab') === key);
        });
      }

      tabs.forEach(function (t, i) {
        t.addEventListener('click', function () { select(t.getAttribute('data-tab')); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          else if (e.key === 'Home') n = 0;
          else if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); select(tabs[n].getAttribute('data-tab'), true); }
        });
      });

      /* Theme-Editor: Zeile anklicken zeigt den passenden Vergleich */
      root.addEventListener('shopify:block:select', function (e) {
        var p = e.target && e.target.closest ? e.target.closest('.vcmp__panel') : null;
        if (p) select(p.getAttribute('data-tab'));
      });

      select(root.getAttribute('data-active') || '1');
    }

    function init(scope) {
      [].slice.call((scope || document).querySelectorAll('[data-vcmp]')).forEach(setup);
    }

    window.vividVergleich = { init: init };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();
})();
